import React from 'react';
import PropTypes from 'prop-types';
import SwatchVariantsRadioGroup from './SwatchVariantsRadioGroup';
import RadioGroup from '../../../shared/components/AriaRadio/RadioGroup';

const SwatchVariants = function SwatchVariantsComponent({ 
    variationGroup, 
    showVariationHandler, 
    pendingRequest }) {
  
    const activeValue = variationGroup.values.find((variation) => variation.selected).displayValue;
    
    const swatch = variationGroup.values.map((variation) => ({
      value: variation.id,
      buttonImageUrl: variation.images.variationSwatch[0].url,
      selected: variation.selected,
      disabled: !variation.selectable,
      action: () => showVariationHandler({url: variation.url, selectable: variation.selectable})
    }));

    return (
      <RadioGroup
        label={variationGroup.displayName}
        showLabel={false}
        activeValue={activeValue}
      >
        <fieldset 
          key={variationGroup.id} 
          className="product-details__variation-group"
          role="none"
        >
          <legend
            id="product_details_variation_group_title"
            className="product-details__variation-group__title"
          >
            {variationGroup.displayName}
            <span className="product-details__variation-display">{activeValue}</span>
          </legend>
          <SwatchVariantsRadioGroup swatch={swatch} pendingRequest={pendingRequest} />
        </fieldset>
      </RadioGroup>
    );
  }
  
  SwatchVariants.propTypes = {
    variationGroup: PropTypes.shape({}).isRequired,
    showVariationHandler: PropTypes.func.isRequired,
    pendingRequest: PropTypes.bool.isRequired,
  };
  
  export default SwatchVariants;
  